module.exports = __webpack_public_path__ + "media/images/emblems/Ayent-143ab8192a1ffd48ac486b1be0707617.png";